global.conmed = global.conmed || {};

conmed.eventsFilter = function ($) {
    'use strict';

    var that = {
        selectors: {
            //regionList = '.region-selector'
        }
    };

    that.init = function () {

        $('#region').on('change', function (e) {
            FilterEvents();
        });



        $('#eventtype').on('change', function (e) {
            FilterEvents();
        });

        $('#specialties').on('change', function (e) {
            FilterEvents();
        });

        $('#roles').on('change', function (e) {
            FilterEvents();
        });

        $('#tags').on('change', function (e) {
            FilterEvents();
        });

        function FilterEvents() {

            var selectedRegion = $('#region').children("option:selected").val();
            var selectedResourceType = $('#resourcetype').children("option:selected").val();
            var selectedEventType = $('#eventtype').children("option:selected").val();
            var selectedRoles = $('#roles').children("option:selected").val();
            var selectedSpecialties = $('#specialties').children("option:selected").val();
            var selectedTags = $('#tags').children("option:selected").val();

            var pathname = window.location.pathname; // Returns path only (/path/example.html)
            var url = window.location.href;     // Returns full URL (https://example.com/path/example.html)
            var origin = window.location.origin;   // Returns base URL (https://example.com)

            var filter = "";
            var regionFilter = "";
            var eventTypeFilter = "";
            var resourceTypeFilter = "";
            var specialtiesFilter = "";
            var rolesFilter = "";
            var tagsFilter = "";

            if (selectedRegion !== "" && selectedRegion !== undefined)
                regionFilter = 'region=' + selectedRegion + '&';

            if (selectedEventType !== "" && selectedEventType !== undefined)
                eventTypeFilter = 'eventtype=' + selectedEventType + '&';

            if (selectedSpecialties !== "" && selectedSpecialties !== undefined)
                specialtiesFilter = 'specialties=' + selectedSpecialties + '&';

            if (selectedRoles !== "" && selectedRoles !== undefined)
                rolesFilter = 'roles=' + selectedRoles + '&';

            if (selectedResourceType !== "" && selectedResourceType !== undefined)
                resourceTypeFilter = 'resourcetype=' + selectedResourceType + '&';

            if (selectedTags !== "" && selectedTags !== undefined)
                tagsFilter = 'tags=' + selectedTags + '&';

            filter = '?' + regionFilter + eventTypeFilter + specialtiesFilter + rolesFilter + resourceTypeFilter + tagsFilter;

            window.location = origin + pathname + filter;

        }



        function getUrlVars() {
            var vars = [], hash;

            var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

            for (var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split('=');
                vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }
            return vars;
        }

        function getQueryVariable(url, variable) {

            var query = url.split('?')[1];

            var vars = query.split('&');

            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (pair[0] == variable) {
                    return pair[1];
                }
            }

            return false;
        }
    };

    return that;
}(jQuery);